import Ajax from '../../../../util/ajax';
export function zigbeeMoveWithOnOff(nid, eid, payload) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/8/command/move-with-on-off';
        const value = {
            'mode': payload.mode,
            'rate': payload.rate
        };
        ajax.post(url, value);
    };
}
